<template lang='pug' src='./accessibility-statement.pug'></template>

<script>
import CustomHeader from 'components/custom/custom-contact-header/custom-contact-header'
import Loader from 'components/loader/loader'
import PageHero from 'components/hero/hero-pages/hero-pages'

import { trigger } from '@/methods'

export default {
  name: 'accessibility-statement',
  computed: {
    props () {
      return this.$store.state.pages['contact']
    },
    propsnew () {
      return this.$store.state.pages['accessibility-statement']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  mixins: [ trigger ],
  components: {
    CustomHeader,
    Loader,
    PageHero
  },
  data () {
    return {
      companyName: 'Patterson Orthodontics', // Fill this in
      domain: "<a href='https://pattersonsmiles.com'>pattersonsmiles.com</a>", // Fill this in
      email: "<a href='mailto:info@pattersonortho.com'>info@pattersonortho.com</a>", // Fill this in
      phone: "<a href='tel:(928) 772-7353'>(928) 772-7353</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility-statement.vue?267b527e